export const SYSTEM_DARK_QUERY = '(prefers-color-scheme: dark)'

export const THEME_MODES = ['auto', 'light', 'dark']

// Light, dark or the system's choice; there is no custom theming. Anything
// else (an old 'custom', nothing at all) follows the system.
export const effectiveThemeMode = (config = {}) =>
  THEME_MODES.includes(config.themeMode) ? config.themeMode : 'auto'

// 'light' or 'dark' for a mode and the system's preference
export const schemeForMode = (mode, prefersDark) => {
  if (mode === 'light' || mode === 'dark') return mode
  return prefersDark ? 'dark' : 'light'
}

export const systemPrefersDark = (view = window) =>
  view.matchMedia ? view.matchMedia(SYSTEM_DARK_QUERY).matches : false

export const watchSystemTheme = (onChange, view = window) => {
  if (!view.matchMedia) {
    return () => {
      // nothing was subscribed, so nothing to unsubscribe
    }
  }
  const query = view.matchMedia(SYSTEM_DARK_QUERY)
  const listener = (event) => onChange(event.matches)
  query.addEventListener('change', listener)
  return () => query.removeEventListener('change', listener)
}
